import React from 'react';

import DashboardIcon from '@atlaskit/icon/core/dashboard';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { useIntl } from 'react-intl';

import type { CommonSideNavItemWithPathProps } from '@townsquare/griffin-navigation/types';

export const DashboardsSideNavItem = (props: CommonSideNavItemWithPathProps): React.JSX.Element => {
	const { isSelected, onClick, item } = props;
	const intl = useIntl();

	return (
		<LinkMenuItem
			onClick={(e) => onClick(item, e)}
			isSelected={isSelected}
			href={item.path}
			elemBefore={<DashboardIcon label="" color={undefined} />}
			testId="side-nav-dashboards"
			elemAfter={
				<Lozenge appearance="discovery">
					{intl.formatMessage({
						id: 'townsquare.atlassian-home.side-nav.dashboards-beta-tag',
						defaultMessage: 'Beta',
						description:
							'The text is shown as a lozenge badge next to the Dashboards item in the left sidebar navigation, indicating the feature is in beta.',
					})}
				</Lozenge>
			}
		>
			{item.name}
		</LinkMenuItem>
	);
};
